import ItemTransaction from 'src/components/TransactionsComponent/ItemTransaction';
import { ITransactionsData } from '@interfaces/transactions';

interface Prop {
  data: ITransactionsData[];
}

function ListTransactions({ data }: Readonly<Prop>) {
  return (
    <>
      {data.map((tr) => (
        <ItemTransaction key={`transaction-list-item-${tr.id}`} transaction={tr} />
      ))}
    </>
  );
}

export default ListTransactions;
